module.exports = __webpack_public_path__ + "img/avatar.9bc3ee65.png";